import { Field, Stack } from "@chakra-ui/react";
import { FORM_GAP, FormError, LoginUI } from "./loginUI";
import type { UseLoginForm } from "./useLoginForm";

export function PasswordForm({
  form,
  ui,
  onUseMagicLink,
  onForgotPassword,
}: {
  form: UseLoginForm;
  ui: LoginUI;
  onUseMagicLink: () => void;
  onForgotPassword: () => void;
}) {
  const {
    email,
    password,
    isValid,
    error,
    isLoading,
    handleEmailChange,
    setPassword,
    loginWithPassword,
  } = form;

  return (
    // Same rhythm as MagicLinkForm: one gap, no per-element margins.
    <Stack
      width="full"
      as="form"
      gap={FORM_GAP}
      onSubmit={(e) => {
        e.preventDefault();
        loginWithPassword();
      }}
    >
      <Field.Root invalid={!isValid} gap={FORM_GAP}>
        {/* The field lays its children out flex-start, and the label itself
            is a flex row — so centring needs full width + justify, not
            text-align. */}
        <Field.Label
          width="100%"
          justifyContent="center"
          textAlign={"center"}
          color="whiteAlpha.700"
        >
          Enter your email and password
        </Field.Label>

        <ui.Input
          type="email"
          placeholder="Email address"
          value={email}
          onChange={handleEmailChange}
        />

        <ui.Input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <FormError isValid={isValid} error={error} />
      </Field.Root>

      <ui.SubmitButton isLoading={isLoading} disabled={isLoading}>
        Login
      </ui.SubmitButton>

      <ui.GhostButton onClick={onForgotPassword}>Forgot password?</ui.GhostButton>

      <ui.GhostButton onClick={onUseMagicLink}>
        Login with magic-link
      </ui.GhostButton>
    </Stack>
  );
}
